// Translation files for English and Hungarian

export const translations = {
  en: {
    // Navigation
    nav: {
      characters: 'Characters',
      categories: 'Categories',
      account: 'Account',
      logout: 'Logout',
    },
    // Login page
    login: {
      title: 'Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Login',
      registerLink: 'Don\'t have an account? Register',
      error: 'Login failed. Please check your credentials.',
      invalidCredentials: 'Invalid username or password',
    },
    // Register page
    register: {
      title: 'Register',
      username: 'Username',
      password: 'Password',
      registerButton: 'Register',
      loginLink: 'Already have an account? Login',
      error: 'Registration failed. Username may already exist.',
      email: 'Email',
      errorGeneric: 'Registration failed. Please try again.',
    },
    // Account page
    account: {
      title: 'Account Management',
      username: 'Username',
      deleteAccount: 'Delete Account',
      confirmDelete: 'Are you sure you want to delete your account? This action cannot be undone.',
      backToCharacters: 'Back to Characters',
      deleteAccountHeading: 'Delete Account',
      confirmWithPassword: 'Confirm with password:',
      confirmDeleteButton: 'Confirm Delete',
      failedDelete: 'Failed to delete account. Please check your password.',
    },
    // Characters page
    characters: {
      title: 'Characters',
      name: 'Name',
      created: 'Created',
      currentDate: 'Current Date',
      dateControls: 'Date Controls',
      actions: 'Actions',
      addCharacter: 'Add Character',
      characterName: 'Character Name',
      create: 'Create',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      manageInventory: 'Manage Inventory',
      manageCategories: 'Manage Categories',
      confirmDelete: 'Are you sure you want to delete this character?',
      editCharacter: 'Edit Character',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      saveChanges: 'Save Changes',
      failedCreate: 'Failed to create character',
      failedDelete: 'Failed to delete character',
      failedIncrement: 'Failed to increment day',
      failedDecrement: 'Failed to decrement day',
      failedUpdate: 'Failed to update character',
      characterNamePlaceholder: 'Character name',
      pyarrCalendarDate: 'Pyarr Calendar Date',
      monthHasDays: 'Each month has 20 days (Day 1-20)',
      characterList: 'Character List',
      noCharacters: 'No characters yet. Create your first character above!',
      yearLabel: 'Year',
      dayLabel: 'Day',
      previousDay: 'Previous day',
      nextDay: 'Next day',
      viewInventory: 'View Inventory',
      addNewCharacter: 'Add New Character',
    },
    // Categories page
    categories: {
      title: 'Categories',
      name: 'Name',
      actions: 'Actions',
      addCategory: 'Add Category',
      categoryName: 'Category Name',
      create: 'Create',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      backToCharacters: 'Back to Characters',
      confirmDelete: 'Are you sure you want to delete this category?',
      editCategory: 'Edit Category',
      categoryManagement: 'Category Management',
      addNewCategory: 'Add New Category',
      categoryNameLabel: 'Category Name*:',
      noCategories: 'No categories found. Add some above!',
      updateCategory: 'Update Category',
      failedSave: 'Failed to save category',
      failedDelete: 'Failed to delete category',
      created: 'Created',
    },
    // Inventory page
    inventory: {
      title: 'Inventory for',
      item: 'Item',
      description: 'Description',
      category: 'Category',
      quantity: 'Qty',
      price: 'Price',
      weight: 'Weight',
      quality: 'Quality',
      added: 'Added',
      modified: 'Modified',
      actions: 'Actions',
      addItem: 'Add Item',
      itemName: 'Item Name',
      itemDescription: 'Description',
      selectCategory: 'Select Category',
      gold: 'Gold',
      silver: 'Silver',
      copper: 'Copper',
      weightKgPerItem: 'Weight (kg per item)',
      kilograms: 'Kilograms',
      qualityLevel: 'Quality',
      create: 'Create',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      backToCharacters: 'Back to Characters',
      confirmDelete: 'Are you sure you want to delete this item?',
      editItem: 'Edit Item',
      filterCategory: 'Filter by Category',
      allCategories: 'All Categories',
      maxPrice: 'Max Price (Copper)',
      totalCopper: 'Total copper',
      maxWeight: 'Max Weight (kg)',
      perItem: 'Per item',
      filters: 'Filters',
      categoryLabel: 'Category:',
      itemNameLabel: 'Item Name:',
      minPriceLabel: 'Min Price (copper):',
      totalCopperPlaceholder: 'Total copper',
      itemNamePlaceholder: 'e.g. sword',
      maxWeightLabel: 'Max Weight (kg):',
      perItemPlaceholder: 'Per item',
      applyFilters: 'Apply Filters',
      clearFilters: 'Clear Filters',
      columnSettings: 'Column Settings',
      showColumns: 'Show/Hide Columns',
      categoryColumn: 'Category',
      itemColumn: 'Item',
      qualityColumn: 'Quality',
      descriptionColumn: 'Description',
      priceColumn: 'Price',
      quantityColumn: 'Quantity',
      weightColumn: 'Weight',
      addedColumn: 'Added Date',
      modifiedColumn: 'Modified Date',
      notesColumn: 'Notes',
      actionsColumn: 'Actions',
      categoryRequired: 'Category*:',
      itemRequired: 'Item*:',
      quantityRequired: 'Quantity*:',
      descriptionRequired: 'Description*:',
      containerOptional: 'Container (optional):',
      containerHelp: 'Select "container" to make this item a bag/pouch that can hold other items',
      containerItemHelp: 'Put this item inside a bag/pouch (must have category "container")',
      inventoryItems: 'Inventory Items',
      noItems: 'No items in inventory. Add some above!',
      allInContainers: 'All items are inside containers. Expand a container above to see items.',
      inContainer: 'in',
      decreaseQuantity: 'Decrease quantity',
      increaseQuantity: 'Increase quantity',
      kgTotal: 'kg (total)',
      kg: 'kg',
      remove: 'Remove',
      containerEmpty: 'This container is empty',
      cannotLoad: 'Cannot load inventory. Please check that you have permission to access this character.',
      errorPrefix: 'Error: ',
      invalidRequest: 'Invalid request. Please check your input.',
      accessDenied: 'Access denied. Please log in again.',
      failedSave: 'Failed to save inventory item',
      enterRemovalReason: 'Enter removal reason:',
      failedRemove: 'Failed to remove item',
      failedUpdateQuantity: 'Failed to update quantity',
      failedLoadContainer: 'Failed to load container contents. Please try again.',
      inventoryManagement: 'Inventory Management',
      addNewItem: 'Add New Item',
      updateItem: 'Update Item',
      noContainer: 'No container',
      priceLabel: 'Price:',
      weightLabel: 'Weight (kg per item):',
      notesLabel: 'Added/Updated Notes:',
      addedUpdated: 'Notes',
      qualityLabel: 'Quality:',
      weightKg: 'Weight (kg)',
      clone: 'Clone',
      cloneItem: 'Clone Item',
      cloneContainer: 'Clone Container',
      cloneContainerQuestion: 'Do you want to copy all items in the container too?',
      cloneWithContents: 'Yes, clone all contents',
      cloneEmpty: 'No, clone empty container',
      cloneCancel: 'Cancel',
      cloneSuccess: 'Cloned',
      cloneContains: 'contains',
      cloneFailed: 'Failed to clone item',
    },
    // Calendar
    calendar: {
      // Seasons
      seasons: {
        'Hideg évszak': 'Cold season',
        'Meleg évszak': 'Warm season',
        'Esős évszak': 'Rainy season',
      },
      // Date format pattern: "{god}'s {ordinal} month, {season}"
      dateFormat: "{god}'s {ordinal} month, {season}",
      // Ordinals
      ordinals: {
        1: '1st',
        2: '2nd',
        3: '3rd',
        4: '4th',
      },
    },
    // Templates page
    templates: {
      title: 'Template Management',
      backToCharacters: 'Back to Characters',
      createNew: 'Create New Template',
      searchTemplates: 'Search Templates',
      name: 'Name',
      category: 'Category',
      item: 'Item',
      type: 'Type',
      price: 'Price',
      quantity: 'Qty',
      actions: 'Actions',
      searchByName: 'Search by name...',
      searchByCategory: 'Search by category...',
      all: 'All',
      simpleItems: 'Simple Items',
      containers: 'Containers',
      pageSize: 'Page Size',
      search: 'Search',
      clear: 'Clear',
      loading: 'Loading...',
      noTemplatesFound: 'No templates found. Create your first template to get started!',
      containerWithItems: 'Container ({count} items)',
      simpleItem: 'Simple Item',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this template?',
      deleteSuccess: 'Template deleted successfully',
      deleteFailed: 'Failed to delete template',
      loadFailed: 'Failed to load templates',
      page: 'Page',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      showing: 'Showing {count} of {total} templates',
      manageTemplates: 'Manage Templates',
      addToCharacter: 'Add to Character',
      addToCharacterTitle: 'Add "{name}" to Character',
      selectCharacter: 'Select Character',
      selectACharacter: 'Select a character...',
      willCreate: 'This will add to inventory:',
      confirmAdd: 'Add to Inventory',
      addSuccess: 'Template added to inventory!',
      addFailed: 'Failed to add template to inventory',
    },
    // Template form page
    templateForm: {
      editTemplate: 'Edit Template',
      createNewTemplate: 'Create New Template',
      backToTemplates: 'Back to Templates',
      templateInformation: 'Template Information',
      nameUnique: 'Name (unique) *',
      namePlaceholder: 'e.g., Healing Kit, Health Potion',
      categoryLabel: 'Category *',
      selectCategory: 'Select Category',
      itemLabel: 'Item *',
      itemPlaceholder: 'e.g., Leather Pouch, Potion Bottle',
      quality: 'Quality',
      qualityPlaceholder: 'e.g., Common, Rare',
      quantityLabel: 'Quantity *',
      priceLabel: 'Price',
      gold: 'Gold',
      silver: 'Silver',
      copper: 'Copper',
      weightKg: 'Weight (kg)',
      isContainer: 'Is Container',
      isContainerHelp: 'Check if this template can contain other items',
      description: 'Description *',
      containerContents: 'Container Contents',
      contentItem: 'Content Item #{number}',
      remove: 'Remove',
      referenceExistingTemplate: 'Reference Existing Template',
      selectTemplate: 'Select Template *',
      selectATemplate: 'Select a template',
      quantityOverride: 'Quantity Override',
      quantityOverrideHelp: 'Leave empty to use template default',
      defineDirectly: 'Define Item Directly',
      categoryRequired: 'Category *',
      itemRequired: 'Item *',
      descriptionRequired: 'Description *',
      quantityRequired: 'Quantity *',
      priceOptional: 'Price (optional)',
      weightOptional: 'Weight (optional, kg)',
      qualityOptional: 'Quality (optional)',
      addContentItem: 'Add Content Item',
      updateTemplate: 'Update Template',
      createTemplate: 'Create Template',
      cancel: 'Cancel',
      createSuccess: 'Template created successfully!',
      updateSuccess: 'Template updated successfully!',
      createFailed: 'Failed to create template',
      updateFailed: 'Failed to update template',
      loadFailed: 'Failed to load template',
      loadCategoriesFailed: 'Failed to load categories',
      loadMore: 'Load more templates...',
      filterTemplates: 'Filter templates...',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      language: 'Language',
    },
  },
  hu: {
    // Navigation
    nav: {
      characters: 'Karakterek',
      categories: 'Kategóriák',
      account: 'Fiók',
      logout: 'Kijelentkezés',
    },
    // Login page
    login: {
      title: 'Bejelentkezés',
      username: 'Felhasználónév',
      password: 'Jelszó',
      loginButton: 'Bejelentkezés',
      registerLink: 'Nincs még fiókod? Regisztráció',
      error: 'Bejelentkezés sikertelen. Kérjük, ellenőrizd az adataidat.',
      invalidCredentials: 'Érvénytelen felhasználónév vagy jelszó',
    },
    // Register page
    register: {
      title: 'Regisztráció',
      username: 'Felhasználónév',
      password: 'Jelszó',
      registerButton: 'Regisztráció',
      loginLink: 'Már van fiókod? Bejelentkezés',
      error: 'Regisztráció sikertelen. A felhasználónév már létezhet.',
      email: 'E-mail',
      errorGeneric: 'Regisztráció sikertelen. Kérlek, próbáld újra.',
    },
    // Account page
    account: {
      title: 'Fiókkezelés',
      username: 'Felhasználónév',
      deleteAccount: 'Fiók törlése',
      confirmDelete: 'Biztosan törölni szeretnéd a fiókodat? Ez a művelet nem visszavonható.',
      backToCharacters: 'Vissza a karakterekhez',
      deleteAccountHeading: 'Fiók törlése',
      confirmWithPassword: 'Erősítsd meg jelszóval:',
      confirmDeleteButton: 'Törlés megerősítése',
      failedDelete: 'Fiók törlése sikertelen. Kérlek, ellenőrizd a jelszavadat.',
    },
    // Characters page
    characters: {
      title: 'Karakterek',
      name: 'Név',
      created: 'Létrehozva',
      currentDate: 'Jelenlegi dátum',
      dateControls: 'Dátum vezérlők',
      actions: 'Műveletek',
      addCharacter: 'Karakter hozzáadása',
      characterName: 'Karakter neve',
      create: 'Létrehozás',
      cancel: 'Mégse',
      delete: 'Törlés',
      edit: 'Szerkesztés',
      manageInventory: 'Felszerelés kezelése',
      manageCategories: 'Kategóriák kezelése',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a karaktert?',
      editCharacter: 'Karakter szerkesztése',
      year: 'Év',
      month: 'Hónap',
      day: 'Nap',
      saveChanges: 'Változtatások mentése',
      failedCreate: 'Karakter létrehozása sikertelen',
      failedDelete: 'Karakter törlése sikertelen',
      failedIncrement: 'Nap növelése sikertelen',
      failedDecrement: 'Nap csökkentése sikertelen',
      failedUpdate: 'Karakter frissítése sikertelen',
      characterNamePlaceholder: 'Karakter neve',
      pyarrCalendarDate: 'Pyarr naptár dátum',
      monthHasDays: 'Minden hónap 20 napos (1-20. nap)',
      characterList: 'Karakter lista',
      noCharacters: 'Még nincsenek karakterek. Hozd létre az elsőt fent!',
      yearLabel: 'Év',
      dayLabel: 'Nap',
      previousDay: 'Előző nap',
      nextDay: 'Következő nap',
      viewInventory: 'Felszerelés megtekintése',
      addNewCharacter: 'Új karakter hozzáadása',
    },
    // Categories page
    categories: {
      title: 'Kategóriák',
      name: 'Név',
      actions: 'Műveletek',
      addCategory: 'Kategória hozzáadása',
      categoryName: 'Kategória neve',
      create: 'Létrehozás',
      cancel: 'Mégse',
      edit: 'Szerkesztés',
      delete: 'Törlés',
      save: 'Mentés',
      backToCharacters: 'Vissza a karakterekhez',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a kategóriát?',
      editCategory: 'Kategória szerkesztése',
      categoryManagement: 'Kategória kezelés',
      addNewCategory: 'Új kategória hozzáadása',
      categoryNameLabel: 'Kategória neve*:',
      noCategories: 'Nincsenek kategóriák. Adj hozzá fent!',
      updateCategory: 'Kategória frissítése',
      failedSave: 'Kategória mentése sikertelen',
      failedDelete: 'Kategória törlése sikertelen',
      created: 'Létrehozva',
    },
    // Inventory page
    inventory: {
      title: 'Felszerelés:',
      item: 'Tárgy',
      description: 'Leírás',
      category: 'Kategória',
      quantity: 'Menny.',
      price: 'Ár',
      weight: 'Súly',
      quality: 'Minőség',
      added: 'Hozzáadva',
      modified: 'Módosítva',
      actions: 'Műveletek',
      addItem: 'Tárgy hozzáadása',
      itemName: 'Tárgy neve',
      itemDescription: 'Leírás',
      selectCategory: 'Kategória kiválasztása',
      gold: 'Arany',
      silver: 'Ezüst',
      copper: 'Réz',
      weightKgPerItem: 'Súly (kg/tárgy)',
      kilograms: 'Kilogramm',
      qualityLevel: 'Minőség',
      create: 'Létrehozás',
      cancel: 'Mégse',
      edit: 'Szerkesztés',
      delete: 'Törlés',
      save: 'Mentés',
      backToCharacters: 'Vissza a karakterekhez',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a tárgyat?',
      editItem: 'Tárgy szerkesztése',
      filterCategory: 'Szűrés kategória szerint',
      allCategories: 'Minden kategória',
      maxPrice: 'Max. ár (réz)',
      totalCopper: 'Összes réz',
      maxWeight: 'Max. súly (kg)',
      perItem: 'Tárgyankénként',
      filters: 'Szűrők',
      categoryLabel: 'Kategória:',
      itemNameLabel: 'Tárgy neve:',
      minPriceLabel: 'Min. ár (réz):',
      totalCopperPlaceholder: 'Összes réz',
      itemNamePlaceholder: 'pl. kard',
      maxWeightLabel: 'Max. súly (kg):',
      perItemPlaceholder: 'Tárgyankénként',
      applyFilters: 'Szűrők alkalmazása',
      clearFilters: 'Szűrők törlése',
      columnSettings: 'Oszlop beállítások',
      showColumns: 'Oszlopok megjelenítése/elrejtése',
      categoryColumn: 'Kategória',
      itemColumn: 'Tárgy',
      qualityColumn: 'Minőség',
      descriptionColumn: 'Leírás',
      priceColumn: 'Ár',
      quantityColumn: 'Mennyiség',
      weightColumn: 'Súly',
      addedColumn: 'Hozzáadva',
      modifiedColumn: 'Módosítva',
      notesColumn: 'Megjegyzések',
      actionsColumn: 'Műveletek',
      categoryRequired: 'Kategória*:',
      itemRequired: 'Tárgy*:',
      quantityRequired: 'Mennyiség*:',
      descriptionRequired: 'Leírás*:',
      containerOptional: 'Tároló (opcionális):',
      containerHelp: 'Válaszd ki a "container" kategóriát, hogy ez a tárgy egy táska/tasak legyen, ami más tárgyakat tud tárolni',
      containerItemHelp: 'Helyezd ezt a tárgyat egy táskába/tasakba (kategóriája "container" kell legyen)',
      inventoryItems: 'Felszerelés tárgyak',
      noItems: 'Nincsenek tárgyak a felszerelésben. Adj hozzá fent!',
      allInContainers: 'Minden tárgy tárolókban van. Bővíts ki egy tárolót fent a tárgyak megjelenítéséhez.',
      inContainer: 'helye:',
      decreaseQuantity: 'Mennyiség csökkentése',
      increaseQuantity: 'Mennyiség növelése',
      kgTotal: 'kg (összesen)',
      kg: 'kg',
      remove: 'Eltávolítás',
      containerEmpty: 'Ez a tároló üres',
      cannotLoad: 'Felszerelés betöltése sikertelen. Kérlek, ellenőrizd, hogy van-e hozzáférésed ehhez a karakterhez.',
      errorPrefix: 'Hiba: ',
      invalidRequest: 'Érvénytelen kérés. Kérlek, ellenőrizd a bevitelt.',
      accessDenied: 'Hozzáférés megtagadva. Kérlek, jelentkezz be újra.',
      failedSave: 'Felszerelés tárgy mentése sikertelen',
      enterRemovalReason: 'Add meg az eltávolítás okát:',
      failedRemove: 'Tárgy eltávolítása sikertelen',
      failedUpdateQuantity: 'Mennyiség frissítése sikertelen',
      failedLoadContainer: 'Tároló tartalmának betöltése sikertelen. Kérlek, próbáld újra.',
      inventoryManagement: 'Felszerelés kezelés',
      addNewItem: 'Új tárgy hozzáadása',
      updateItem: 'Tárgy frissítése',
      noContainer: 'Nincs tároló',
      priceLabel: 'Ár:',
      weightLabel: 'Súly (kg/tárgy):',
      notesLabel: 'Hozzáadva/Frissítve megjegyzések:',
      addedUpdated: 'Megjegyzések',
      qualityLabel: 'Minőség:',
      weightKg: 'Súly (kg)',
      clone: 'Klónozás',
      cloneItem: 'Tárgy klónozása',
      cloneContainer: 'Tároló klónozása',
      cloneContainerQuestion: 'Szeretnéd a tároló összes tárgyát is másolni?',
      cloneWithContents: 'Igen, klónozd az összes tartalmat',
      cloneEmpty: 'Nem, klónozd üres tárolóként',
      cloneCancel: 'Mégse',
      cloneSuccess: 'Klónozva',
      cloneContains: 'tartalmaz',
      cloneFailed: 'Tárgy klónozása sikertelen',
    },
    // Calendar
    calendar: {
      // Seasons (kept in Hungarian)
      seasons: {
        'Hideg évszak': 'Hideg évszak',
        'Meleg évszak': 'Meleg évszak',
        'Esős évszak': 'Esős évszak',
      },
      // Date format pattern: "{god} {ordinal}. hónapja, {season}"
      dateFormat: "{god} {ordinal}. hónapja, {season}",
      // Ordinals (just numbers in Hungarian)
      ordinals: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
      },
    },
    // Templates page
    templates: {
      title: 'Sablon kezelés',
      backToCharacters: 'Vissza a karakterekhez',
      createNew: 'Új sablon létrehozása',
      searchTemplates: 'Sablonok keresése',
      name: 'Név',
      category: 'Kategória',
      item: 'Tárgy',
      type: 'Típus',
      price: 'Ár',
      quantity: 'Menny.',
      actions: 'Műveletek',
      searchByName: 'Keresés név szerint...',
      searchByCategory: 'Keresés kategória szerint...',
      all: 'Összes',
      simpleItems: 'Egyszerű tárgyak',
      containers: 'Tárolók',
      pageSize: 'Oldalméret',
      search: 'Keresés',
      clear: 'Törlés',
      loading: 'Betöltés...',
      noTemplatesFound: 'Nem találhatók sablonok. Hozd létre az első sablont!',
      containerWithItems: 'Tároló ({count} tárgy)',
      simpleItem: 'Egyszerű tárgy',
      view: 'Megtekintés',
      edit: 'Szerkesztés',
      delete: 'Törlés',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a sablont?',
      deleteSuccess: 'Sablon sikeresen törölve',
      deleteFailed: 'Sablon törlése sikertelen',
      loadFailed: 'Sablonok betöltése sikertelen',
      page: 'Oldal',
      of: '/',
      previous: 'Előző',
      next: 'Következő',
      showing: '{count} / {total} sablon megjelenítve',
      manageTemplates: 'Sablonok kezelése',
      addToCharacter: 'Karakterhez adás',
      addToCharacterTitle: '"{name}" hozzáadása karakterhez',
      selectCharacter: 'Karakter kiválasztása',
      selectACharacter: 'Válassz egy karaktert...',
      willCreate: 'Ez a következőket adja a felszereléshez:',
      confirmAdd: 'Hozzáadás a felszereléshez',
      addSuccess: 'Sablon hozzáadva a felszereléshez!',
      addFailed: 'Sablon hozzáadása sikertelen',
    },
    // Template form page
    templateForm: {
      editTemplate: 'Sablon szerkesztése',
      createNewTemplate: 'Új sablon létrehozása',
      backToTemplates: 'Vissza a sablonokhoz',
      templateInformation: 'Sablon információk',
      nameUnique: 'Név (egyedi) *',
      namePlaceholder: 'pl. Gyógyító készlet, Életerő bájital',
      categoryLabel: 'Kategória *',
      selectCategory: 'Kategória kiválasztása',
      itemLabel: 'Tárgy *',
      itemPlaceholder: 'pl. Bőrtáska, Bájitaltartó',
      quality: 'Minőség',
      qualityPlaceholder: 'pl. Közönséges, Ritka',
      quantityLabel: 'Mennyiség *',
      priceLabel: 'Ár',
      gold: 'Arany',
      silver: 'Ezüst',
      copper: 'Réz',
      weightKg: 'Súly (kg)',
      isContainer: 'Tároló',
      isContainerHelp: 'Jelöld be, ha ez a sablon más tárgyakat tartalmazhat',
      description: 'Leírás *',
      containerContents: 'Tároló tartalma',
      contentItem: 'Tartalom #{number}',
      remove: 'Eltávolítás',
      referenceExistingTemplate: 'Meglévő sablon hivatkozása',
      selectTemplate: 'Sablon kiválasztása *',
      selectATemplate: 'Válassz egy sablont',
      quantityOverride: 'Mennyiség felülbírálása',
      quantityOverrideHelp: 'Hagyd üresen a sablon alapértelmezett értékéhez',
      defineDirectly: 'Tárgy közvetlen megadása',
      categoryRequired: 'Kategória *',
      itemRequired: 'Tárgy *',
      descriptionRequired: 'Leírás *',
      quantityRequired: 'Mennyiség *',
      priceOptional: 'Ár (opcionális)',
      weightOptional: 'Súly (opcionális, kg)',
      qualityOptional: 'Minőség (opcionális)',
      addContentItem: 'Tartalom hozzáadása',
      updateTemplate: 'Sablon frissítése',
      createTemplate: 'Sablon létrehozása',
      cancel: 'Mégse',
      createSuccess: 'Sablon sikeresen létrehozva!',
      updateSuccess: 'Sablon sikeresen frissítve!',
      createFailed: 'Sablon létrehozása sikertelen',
      updateFailed: 'Sablon frissítése sikertelen',
      loadFailed: 'Sablon betöltése sikertelen',
      loadCategoriesFailed: 'Kategóriák betöltése sikertelen',
      loadMore: 'További sablonok betöltése...',
      filterTemplates: 'Sablonok szűrése...',
    },
    // Common
    common: {
      loading: 'Betöltés...',
      error: 'Hiba',
      success: 'Siker',
      language: 'Nyelv',
    },
  },
};

export type Language = 'en' | 'hu';
export type TranslationKeys = typeof translations.en;
